// Modules
import PropTypes from 'prop-types';
import React from 'react';

import { stopPropagation } from 'utils/event-handlers';
import Overlay from 'praece-react-bootstrap/lib/Overlay';
import Popover from 'praece-react-bootstrap/lib/Popover';
import SVG from 'components/widgets/icons/svg';

import DriveFilesList from './drive-files-list';

export default class DriveFiles extends React.Component {
  static propTypes = {
    folder: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.state = { showPopover: false };

    this.show = () => this.setState({ showPopover: true });
    this.hide = () => this.setState({ showPopover: false });
  }

  render() {
    const { folder } = this.props;
    const { showPopover } = this.state;

    return (
      <div onClick={stopPropagation(this.show)} className="drive-files-wrapper">
        <SVG src="svg/google-drive.svg" className="google-drive" />
        <Overlay
          shouldUpdatePosition
          onEnter={this.configureOverlay}
          rootClose
          placement="bottom"
          target={this}
          onHide={this.hide}
          show={showPopover}
        >
          <Popover
            id="drive-files-window"
            className="clickable-options-list p-0 linked-clickable-options-list"
            onClick={stopPropagation()}
            onMouseOver={stopPropagation()}
          >
            <DriveFilesList folder={folder} />
          </Popover>
        </Overlay>
      </div>
    );
  }
}

